import { Locale, type LocalizedString } from "./Locale.js";

export const namesOfEventCategories = {
	christmas: { [Locale.cs]: "Vánoce" },
	valentines: { [Locale.cs]: "Valentýn" },
	easter: { [Locale.cs]: "Velikonoce" },
} satisfies Record<string, LocalizedString>;
